
import React from 'react';
import { FlowRender } from "../flow-render";
import { Name } from "../prm/name";
import { Text } from "../prm/text";
import {SourceOfFundsRadioButton, OTHER_INDEX} from "./source-of-funds-radio-button";
import {GreyBox} from "../../client/funcs/utils";
import faker from 'faker';

const role_0_source_of_funds = new SourceOfFundsRadioButton(
  new Name("role_0_source_of_funds"));
const role_0_source_of_funds_other = new Text(
  new Name("role_0_source_of_funds_other"));

class SourceOfFunds extends FlowRender {
  constructor(index) {
    super(index, [
      role_0_source_of_funds,
      role_0_source_of_funds_other,
    ]);
    role_0_source_of_funds.onChangeCallback = this.onChange;
    role_0_source_of_funds_other.onChangeCallback = this.onChange;
  }

  canNavigateNext(component) {
    const highlight_rects = [];
    const filled = role_0_source_of_funds.isFilledElseHighlight(
      component.state, highlight_rects);
    const is_other_clicked = role_0_source_of_funds.isItemClicked(
      OTHER_INDEX, component.state);

    if (filled) {
      if ((is_other_clicked && role_0_source_of_funds_other.isFilledElseHighlight(
        component.state, highlight_rects)) || !is_other_clicked) {
        return component.getRootUrl() + "/employment";
      }
    }

    component.setState({ highlight_rects });
    return null;
  }

  onChange = (component, state) => {
    const is_other_selected =
      role_0_source_of_funds.isItemClicked(OTHER_INDEX, state);
    role_0_source_of_funds_other.setDisabled(state, !is_other_selected);
  }

  setRandomValues(state, component) {
    super.setRandomValues(state, component);
    const max_index = role_0_source_of_funds.buttonList.length - 1;
    let index = 0;

    while((index = faker.random.number({min: 0, max: max_index })) <= 0) {}
    const id = role_0_source_of_funds.buttonList[index].id.split("|")[1];
    role_0_source_of_funds.clear(state);
    role_0_source_of_funds.setValues(state, [id], true);

    if (index === OTHER_INDEX) {
      role_0_source_of_funds_other.setValue(component.state, "OTHER");
    }
  }

  dumpButtons = component => {
    const buttons = [];
    const prm = role_0_source_of_funds;
    const container_style = {
      display: "flex",
      alignItems: "center",
      marginBottom: "0.5rem",
    }
    const label_style = {
      marginLeft: "1rem",
    }
    for(let i=0; i < prm.buttonList.length; i++) {
      const button = prm.buttonList[i];
      const id_suffix = button.id.split("|").pop();
      if (id_suffix === "accountsReceivable") {
        continue;
      }
      let other = null;
      if (id_suffix === "other") {
        other = (
          <div style={{ flex: "1", marginLeft: "1rem"}}>
            { role_0_source_of_funds_other.renderInput(
              component, { width: "100%"}) }
          </div>
        )
      }
      buttons.push((
        <div key={i} style={container_style}>
          <div>
            { prm.renderCheckbox(i, component) }
          </div>
          <div>
            { prm.renderLabel(i, component.state, label_style) }
          </div>
          { other }
        </div>
      ))
    }
    return buttons;
  }

  render = component => {

    const header_text = "What do you expect will be the initial source of funds for this account?";
    const header_style = {
      marginBottom: "1rem",
    }
    const container_style = {
      width: "50%",
      margin: "auto",
    }
    return (
      <div>
        { this.renderHighlightRects(component) }
        { this.renderTitle(component, "Source of Funds", "75%") }
        { this.renderProgress(component, "75%") }
        <section className={"section"}>
          <div style={container_style}>
            <div style={header_style}>
              { header_text}
            </div>
            <GreyBox>
              { this.dumpButtons(component) }
            </GreyBox>
          </div>
          { this.renderNextButtonRow(component, true) }
        </section>
      </div>
    )
  }
}

export { SourceOfFunds };
